export default __webpack_public_path__ + "static/media/2.6f95b1f3.png";